import { useCallback } from 'react';

import { useAuthActionsContext } from '~context/auth';
import type { AuthSuccessCallbackType } from '~context/auth/types';
import type { RegisterAnalytics } from '~features/annals/types';
import { useSession } from '~hooks/useSession';

export function useRequireAuth(
	props?: { preventAction?: boolean } | undefined
) {
	const preventAction = props?.preventAction ?? false;
	const { isDemoUser } = useSession();
	const { openRegister, openLogin } = useAuthActionsContext();

	return useCallback(
		<T extends unknown[]>(
			callback: (...args: T) => void,
			options?: {
				modalType?: AuthSuccessCallbackType;
				analytics?: RegisterAnalytics;
			}
		) => {
			const { modalType = 'register', analytics } = options || {};

			return (...args: T) => {
				if (isDemoUser) {
					const openModal = modalType === 'login' ? openLogin : openRegister;
					openModal({
						cb: () => (preventAction ? null : callback(...args)),
						analytics,
					});
				} else {
					callback(...args);
				}
			};
		},
		[isDemoUser, openLogin, openRegister, preventAction]
	);
}
